/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputControlFrequency } from './InputControlFrequency';
import {
    InputControlFrequencyFromJSON,
    InputControlFrequencyFromJSONTyped,
    InputControlFrequencyToJSON,
} from './InputControlFrequency';

/**
 * 
 * @export
 * @interface InputStartSession
 */
export interface InputStartSession {
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    band?: string;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    band2?: string;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    channel?: string;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    channel2?: string;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    connectionType?: InputStartSessionConnectionTypeEnum;
    /**
     * 
     * @type {InputControlFrequency}
     * @memberof InputStartSession
     */
    controlFrequency?: InputControlFrequency;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    direction?: string;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    directionCoordinates?: string;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    directionName?: string;
    /**
     * 
     * @type {InputControlFrequency}
     * @memberof InputStartSession
     */
    freq?: InputControlFrequency;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    missionType: InputStartSessionMissionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof InputStartSession
     */
    pilot: number;
    /**
     * 
     * @type {string}
     * @memberof InputStartSession
     */
    repeaterChannel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InputStartSession
     */
    withRepeater?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InputStartSession
     */
    zone: number;
}


/**
 * @export
 */
export const InputStartSessionConnectionTypeEnum = {
    Optic: 'optic',
    Starlink: 'starlink',
    Lte: 'lte',
    Ocusync: 'ocusync',
    Nakande: 'nakande',
    Unknown: 'unknown'
} as const;
export type InputStartSessionConnectionTypeEnum = typeof InputStartSessionConnectionTypeEnum[keyof typeof InputStartSessionConnectionTypeEnum];

/**
 * @export
 */
export const InputStartSessionMissionTypeEnum = {
    Radio: 'radio',
    Digital: 'digital',
    Bomber: 'bomber'
} as const;
export type InputStartSessionMissionTypeEnum = typeof InputStartSessionMissionTypeEnum[keyof typeof InputStartSessionMissionTypeEnum];


/**
 * Check if a given object implements the InputStartSession interface.
 */
export function instanceOfInputStartSession(value: object): boolean {
    if (!('missionType' in value)) return false;
    if (!('pilot' in value)) return false;
    if (!('zone' in value)) return false;
    return true;
}

export function InputStartSessionFromJSON(json: any): InputStartSession {
    return InputStartSessionFromJSONTyped(json, false);
}

export function InputStartSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputStartSession {
    if (json == null) {
        return json;
    }
    return {
        
        'band': json['band'] == null ? undefined : json['band'],
        'band2': json['band2'] == null ? undefined : json['band2'],
        'channel': json['channel'] == null ? undefined : json['channel'],
        'channel2': json['channel2'] == null ? undefined : json['channel2'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'connectionType': json['connectionType'] == null ? undefined : json['connectionType'],
        'controlFrequency': json['controlFrequency'] == null ? undefined : InputControlFrequencyFromJSON(json['controlFrequency']),
        'direction': json['direction'] == null ? undefined : json['direction'],
        'directionCoordinates': json['directionCoordinates'] == null ? undefined : json['directionCoordinates'],
        'directionName': json['directionName'] == null ? undefined : json['directionName'],
        'freq': json['freq'] == null ? undefined : InputControlFrequencyFromJSON(json['freq']),
        'missionType': json['missionType'],
        'pilot': json['pilot'],
        'repeaterChannel': json['repeaterChannel'] == null ? undefined : json['repeaterChannel'],
        'withRepeater': json['withRepeater'] == null ? undefined : json['withRepeater'],
        'zone': json['zone'],
    };
}

export function InputStartSessionToJSON(value?: InputStartSession | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'band': value['band'],
        'band2': value['band2'],
        'channel': value['channel'],
        'channel2': value['channel2'],
        'comment': value['comment'],
        'connectionType': value['connectionType'],
        'controlFrequency': InputControlFrequencyToJSON(value['controlFrequency']),
        'direction': value['direction'],
        'directionCoordinates': value['directionCoordinates'],
        'directionName': value['directionName'],
        'freq': InputControlFrequencyToJSON(value['freq']),
        'missionType': value['missionType'],
        'pilot': value['pilot'],
        'repeaterChannel': value['repeaterChannel'],
        'withRepeater': value['withRepeater'],
        'zone': value['zone'],
    };
}

